import * as React from "react";
import { SVGProps } from "react";
export const PrinterFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15 5.833H4.99999V3.375C4.99999 3.139 5.08666 2.934 5.25999 2.76C5.43399 2.58667 5.63899 2.5 5.87499 2.5H14.125C14.361 2.5 14.566 2.58667 14.74 2.76C14.9133 2.934 15 3.139 15 3.375V5.833ZM15 10.646C15.236 10.646 15.441 10.559 15.615 10.385C15.7883 10.2117 15.875 10.007 15.875 9.771C15.875 9.535 15.7883 9.33 15.615 9.156C15.441 8.98267 15.236 8.896 15 8.896C14.764 8.896 14.559 8.98267 14.385 9.156C14.2117 9.33 14.125 9.535 14.125 9.771C14.125 10.007 14.2117 10.2117 14.385 10.385C14.559 10.559 14.764 10.646 15 10.646ZM6.74999 15.75H13.25V12.833H6.74999V15.75ZM6.74999 17.5C6.26399 17.5 5.85066 17.33 5.50999 16.99C5.16999 16.6493 4.99999 16.236 4.99999 15.75V14.438H2.54199C2.30599 14.438 2.10099 14.351 1.92699 14.177C1.75366 14.0037 1.66699 13.7987 1.66699 13.562V9.271C1.66699 8.56233 1.91699 7.958 2.41699 7.458C2.91699 6.958 3.52099 6.708 4.22899 6.708H15.771C16.479 6.708 17.083 6.958 17.583 7.458C18.083 7.958 18.333 8.56233 18.333 9.271V13.562C18.333 13.7987 18.2463 14.0037 18.073 14.177C17.899 14.351 17.694 14.438 17.458 14.438H15V15.75C15 16.236 14.83 16.6493 14.49 16.99C14.1493 17.33 13.736 17.5 13.25 17.5H6.74999Z"
            fill="currentColor"
        />
    </svg>
);
PrinterFillIcon.displayName = "PrinterFillIcon";
